import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useOmuiLdFlags = createFlagsHook<typeof import('./flags.json')>()
